<div class="plan-members">
  <ng-content></ng-content>
</div>
